import { useState, useEffect } from "react";

import classnames from "classnames";

import Swal from "sweetalert2";

import { v4 as uuidv4 } from "uuid";

import { useNavigate, useParams } from "react-router-dom";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../util/firebase";
// eslint-disable-next-line
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";

import BarLoader from "react-spinners/BarLoader";
import {
  FaChevronLeft,
  FaCheck,
  FaRegClock,
  FaCheckDouble,
} from "react-icons/fa";
// eslint-disable-next-line
import { Button, Input, Modal, ModalBody } from "reactstrap";
// eslint-disable-next-line
import { IoClose, IoRibbon, IoWarning } from "react-icons/io5";

import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";

import { useTranslation } from "react-i18next";
import Avatar from "../../../components/Avatar/Avatar";

import emailjs from "@emailjs/browser";

function RoomPage() {
  const { t } = useTranslation("common");

  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const navigate = useNavigate();
  const params = useParams();
  const leagueUid = params.leagueUid;
  const roomUid = params.roomUid;

  const [isLoading, setIsLoading] = useState(false);

  // eslint-disable-next-line
  const [league, setLeague] = useState();
  const fetchLeague = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "leagues"), where("uid", "==", leagueUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setLeague(data);

      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching league");
    }
  };
  useEffect(() => {
    fetchLeague();
    // eslint-disable-next-line
  }, []);

  function compareByPoints(a, b) {
    return b.total - a.total;
  }

  // eslint-disable-next-line
  const [room, setRoom] = useState();
  const fetchRoom = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setRoom(data);

      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching room");
    }
  };
  useEffect(() => {
    fetchRoom();
    // eslint-disable-next-line
  }, []);

  const [groups, setGroups] = useState();
  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      let fetchedGroups = [];
      let allGroupsForLeague = []; // Track all groups before type filtering

      const q = query(
        collection(db, "groups"),
        where("league", "==", league.name)
      );
      const docs = await getDocs(q);
      docs?.forEach((doc) => {
        const newGroup = doc.data();

        // Track all groups for this tournament before filtering by type
        const norm = (s) => (s || "").toString().trim().toLowerCase();
        const matchesTournament =
          newGroup.tournament &&
          room?.season &&
          norm(newGroup.tournament) === norm(room.season);
        if (matchesTournament) {
          allGroupsForLeague.push(newGroup);
        }

        // New groups use `tournament` (season string) and may include `tournamentRoomUid`.
        // Match groups to this room by (in order): tournamentRoomUid === room.uid,
        // tournament === room.season, or legacy season === room.season.
        const matchesByRoomUid =
          newGroup.tournamentRoomUid &&
          room?.uid &&
          newGroup.tournamentRoomUid === room.uid;
        const matchesByTournament =
          newGroup.tournament &&
          room?.season &&
          norm(newGroup.tournament) === norm(room.season);
        const matchesByLegacySeason =
          newGroup.season &&
          room?.season &&
          norm(newGroup.season) === norm(room.season);

        // Require tournamentType to match when group was created per-tournament (new behavior).
        // Treat missing tournamentType (legacy docs) as 'casual' so older groups/rooms
        // without an explicit type are considered casual and will match casual rooms.
        const groupTypeRaw = newGroup.tournamentType || newGroup.tournamenttype;
        const roomTypeRaw = room?.tournamentType || room?.tournamenttype;
        const groupType = (groupTypeRaw || "casual").toString();
        const roomType = (roomTypeRaw || "casual").toString();
        const matchesByType = norm(groupType) === norm(roomType);

        // Special-case legacy league where some groups omit season (keep previous behavior)
        if (
          league.name === "Liga Mayor de Futbol Salvadoreño" &&
          room.season === "Apertura 2024"
        ) {
          if (!newGroup.season) {
            fetchedGroups.push(newGroup);
          } else if (
            (matchesByRoomUid || matchesByTournament) &&
            matchesByType
          ) {
            fetchedGroups.push(newGroup);
          }
        } else {
          if (
            (matchesByRoomUid ||
              matchesByTournament ||
              matchesByLegacySeason) &&
            matchesByType
          ) {
            fetchedGroups.push(newGroup);
          }
        }
      });

      fetchedGroups.sort((a, b) => {
        return new Date(b.dateCreated) - new Date(a.dateCreated);
      });

      // Deduplicate variants of the same tournament so Room shows a single representative group.
      // Key by tournament (fallback season/name). If multiple variants exist choose the one
      // matching the room's tournamentType when possible.
      const norm = (s) => (s || "").toString().trim().toLowerCase();
      const grouped = new Map();
      for (const g of fetchedGroups) {
        // Use a composite key: tournament (or season) + name. This prevents
        // distinct matchdays (which have different `name` values) from being
        // collapsed together when they share the same tournament/season.
        const top = g.tournament || g.season || "";
        const key = norm(`${top}|${g.name || ""}`);
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(g);
      }

      const deduped = [];
      // When deduplicating prefer a variant that matches the room's tournamentType.
      // Default missing types to 'casual' so legacy docs are treated consistently.
      const roomType = norm(
        room?.tournamentType || room?.tournamenttype || "casual"
      );
      for (const arr of grouped.values()) {
        if (arr.length === 1) {
          deduped.push(arr[0]);
          continue;
        }

        // prefer a variant that matches room's tournamentType
        let chosen = arr.find(
          (x) => norm(x.tournamentType || x.tournamenttype || "") === roomType
        );
        if (!chosen) {
          // otherwise prefer the one that has no tournamentType (legacy) or just the first
          chosen =
            arr.find((x) => !(x.tournamentType || x.tournamenttype)) || arr[0];
        }
        deduped.push(chosen);
      }

      // Debug: log all groups for this tournament across ALL types
      console.log("=== TOURNAMENT ANALYSIS ===");
      console.log("Room type:", roomType);
      console.log("Room league:", room?.leagueName);
      console.log("Room season:", room?.season);
      console.log("\n--- ALL Groups for this tournament (all types) ---");
      console.log("Total count:", allGroupsForLeague.length);

      // Group by tournamentType to see distribution
      const byType = {};
      allGroupsForLeague.forEach((g) => {
        const type = g.tournamentType || g.tournamenttype || "no-type";
        if (!byType[type]) byType[type] = [];
        byType[type].push(g);
      });

      console.log("\nGroups by tournament type:");
      Object.keys(byType).forEach((type) => {
        console.log(`  ${type}: ${byType[type].length} groups`);
        byType[type].forEach((g) => {
          console.log(`    - ${g.name} (uid: ${g.uid.substring(0, 8)}...)`);
        });
      });

      console.log("\n--- Groups matching this room's type (highStakes) ---");
      console.log(
        "Fetched groups (after type filtering):",
        fetchedGroups.length
      );
      console.log("Deduped groups:", deduped.length);

      // eslint-disable-next-line
      import("../../../util/logger").then(({ debug }) =>
        debug(
          "fetchedGroups count:",
          fetchedGroups.length,
          "deduped count:",
          deduped.length
        )
      );
      // Use deduped list - one group per matchday for this tournament type
      setGroups(deduped);

      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching groups");
    }
  };
  useEffect(() => {
    if (league && room) {
      fetchGroups();
    }
    // eslint-disable-next-line
  }, [league, room]);

  const getLeaderboardReward = (rank, potSize) => {
    switch (rank) {
      case 1:
        return ((potSize * 0.21).toFixed(2) * 100).toFixed(0);
      case 2:
        return ((potSize * 0.16).toFixed(2) * 100).toFixed(0);
      case 3:
        return ((potSize * 0.11).toFixed(2) * 100).toFixed(0);
      case 4:
        return ((potSize * 0.1).toFixed(2) * 100).toFixed(0);
      case 5:
        return ((potSize * 0.09).toFixed(2) * 100).toFixed(0);
      case 6:
        return ((potSize * 0.08).toFixed(2) * 100).toFixed(0);
      case 7:
        return ((potSize * 0.07).toFixed(2) * 100).toFixed(0);
      case 8:
        return ((potSize * 0.06).toFixed(2) * 100).toFixed(0);
      case 9:
        return ((potSize * 0.06).toFixed(2) * 100).toFixed(0);
      case 10:
        return ((potSize * 0.06).toFixed(2) * 100).toFixed(0);
      default:
        return "0";
    }
  };

  const [roomMembers, setRoomMembers] = useState();
  const getRoomMembers = () => {
    let fetchedRoomMembers = [...room.members];

    fetchedRoomMembers.forEach((member) => {
      let challengesWon = 0;
      let points = 0;
      let starPoints = 0;
      let total = 0;

      room?.submissions?.forEach((submission) => {
        if (submission.submitterUid === member.uid) {
          const group = groups.find((e) => e.uid === submission.groupUid);

          let userChallengesWon = room?.challenges?.filter((e) =>
            e.bets.some(
              (b) => b.bettorUid === member.uid && b.result === e.result
            )
          ).length
            ? room?.challenges?.filter((e) =>
                e.bets.some(
                  (b) => b.bettorUid === member.uid && b.result === e.result
                )
              ).length
            : 0;

          let userPoints = 0;
          let userStarPoints = 0;

          if (room?.leagueSport === "RACING") {
            // console.log(submission?.positions.firstPolePositionDriver, group?.drivers.find(e => e.result === 'firstPolePosition')?.name)
            if (
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (submission?.positions.fastestLapDriver === group?.fastestLap) {
              userPoints += 1;
            }
          } else {
            submission?.events.forEach((event) => {
              if (
                event.selectedResult ===
                group?.events.find(
                  (e) =>
                    e.homeTeam === event.homeTeam &&
                    e.awayTeam === event.awayTeam
                )?.result
              ) {
                if (event.isStarGame) {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    userStarPoints += 1;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    userStarPoints += 4;
                  } else {
                    userStarPoints += 6;
                  }
                } else {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    userPoints += 0.25;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    userPoints += 2;
                  } else {
                    userPoints += 3;
                  }
                }
              } else if (
                group?.events.find(
                  (e) =>
                    e.homeTeam === event.homeTeam &&
                    e.awayTeam === event.awayTeam
                )?.result === "Draw" &&
                (event.selectedResult === "Home" ||
                  event.selectedResult === "Away")
              ) {
                if (event.isStarGame) {
                  userStarPoints += 2;
                } else {
                  userPoints += 1;
                }
              }
            });
          }

          challengesWon = userChallengesWon;
          points += userPoints;
          starPoints += userStarPoints;
          total += userPoints + userStarPoints;
        }
      });

      member.challengesWon = challengesWon;
      member.points = points;
      member.starPoints = starPoints;
      member.total = total;
      if (member.name === "Jose Miguel" && roomUid === "5") {
        member.total += 71;
      }
    });

    fetchedRoomMembers.sort(compareByPoints);
    fetchedRoomMembers.forEach((member, index) => {
      member.place = index + 1;
    });

    // console.log(fetchedRoomMembers);
    fetchedRoomMembers.forEach((member) => {
      let reward = getLeaderboardReward(
        member.place,
        fetchedRoomMembers.length * 4.99
      );

      member.reward = fetchedRoomMembers.length < 10 ? 0 : reward;
    });

    setRoomMembers(fetchedRoomMembers);
  };
  useEffect(() => {
    if (room && groups) {
      getRoomMembers();
    }
    // eslint-disable-next-line
  }, [room, groups]);

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const leaveRoom = async () => {
    Swal.fire({
      text: t("areYouSureYouWantToLeaveTournament"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: t("yesLeaveTournament"),
      cancelButtonText: t("noCancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);
            let newMemberUids = [...newRoom.memberUids];
            newMemberUids = newMemberUids.filter((e) => e !== user.uid);
            let newMembers = [...newRoom.members];
            newMembers = newMembers.filter((e) => e.uid !== user.uid);

            await updateDoc(getRoom, {
              memberUids: newMemberUids,
              members: newMembers,
            });

            navigate(-1);

            Swal.fire({
              text: t("publicTournamentAbandoned"),
              icon: "success",
              confirmButtonColor: "#005EE1",
              confirmButtonText: t("ok"),
            });

            setIsLoading(false);
          });
        } catch (err) {
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const [groupForModal, setGroupForModal] = useState();
  const [groupModalIsVisible, setGroupModalIsVisible] = useState(false);
  const toggleGroupModal = (group) => {
    if (group) {
      setGroupForModal(group);
    }
    setGroupModalIsVisible(!groupModalIsVisible);
  };

  const [leaderboardUserModalIsVisible, setLeaderboardUserModalIsVisible] =
    useState(false);
  // eslint-disable-next-line
  const [userForLeaderboardModal, setUserForLeaderboardModal] = useState();
  const toggleLeaderboardUserModal = (leaderboardUser) => {
    leaderboardUser && setUserForLeaderboardModal(leaderboardUser);
    setLeaderboardUserModalIsVisible(!leaderboardUserModalIsVisible);
  };

  // eslint-disable-next-line
  const leaderboardColumns =
    room?.leagueSport === "RACING"
      ? [
          {
            field: "place",
            headerName: "Place",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "points",
            headerName: "Points",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "starPoints",
            headerName: "Star points",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "total",
            headerName: "Total",
            flex: 1,
            minWidth: 150,
            maxWidth: 120,
          },
        ]
      : [
          {
            field: "place",
            headerName: "Place",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "challengesWon",
            headerName: "Challenges won",
            flex: 1,
            minWidth: 175,
            maxWidth: 225,
          },
          {
            field: "points",
            headerName: "Points",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "starPoints",
            headerName: "Star points",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "total",
            headerName: "Total",
            flex: 1,
            minWidth: 150,
            maxWidth: 120,
          },
          {
            field: "reward",
            headerName: t("reward"),
            flex: 1,
            minWidth: 150,
            maxWidth: 150,
          },
        ];

  const leaderboardUserColumns = [
    {
      field: "group",
      headerName: "Group",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "challengesWon",
      headerName: "Challenges won",
      flex: 1,
      minWidth: 175,
      maxWidth: 225,
    },
    {
      field: "points",
      headerName: "Points",
      flex: 1,
      minWidth: 125,
      maxWidth: 175,
    },
    {
      field: "starPoints",
      headerName: "Star points",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
    },
  ];

  // const getUserChallengesWonForGroup = (groupUid, userUid) => {
  //   let challengesWon = 0;

  //   room?.challenges?.forEach(challenge => {
  //     if (challenge.event.groupUid === groupUid && challenge.bets.some(e => e.bettorUid === userUid && e.result === challenge.result)){
  //       challengesWon++;
  //     }
  //   })

  //   return challengesWon;
  // }

  // const getUserPointsForGroup = (groupUid, userUid) => {
  //   let points = 0;

  //   room?.submissions?.forEach(submission => {
  //     if (submission.groupUid === groupUid && submission.submitterUid === userUid){
  //       submission.events.forEach(event => {
  //         if (event.selectedResult === groups.find(e => e.uid === groupUid).events.find(e => e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam).result){
  //           console.log(event.selectedResult, groups.find(e => e.uid === groupUid).events.find(e => e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam).result)
  //           points++;
  //         }
  //       })
  //     }
  //   })

  //   return points;
  // }

  // const getUserStarPointsForGroup = (groupUid, userUid) => {
  //   let starPoints = 0;

  //   room?.submissions?.forEach(submission => {
  //     if (submission.groupUid === groupUid && submission.submitterUid === userUid){
  //       submission.events.forEach(event => {
  //         if (event.selectedResult === groups.find(e => e.uid === groupUid).events.find(e => e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam).result){
  //           if (groups.find(e => e.uid === groupUid).events.find(e => e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam).isStarGame){
  //             starPoints++;
  //           }
  //         }
  //       })
  //     }
  //   })

  //   return starPoints;
  // }

  // const getUserTotalForGroup = (groupUid, userUid) => {
  //   return getUserPointsForGroup(groupUid, userUid) + getUserStarPointsForGroup(groupUid, userUid);
  // }

  const [leaderboardUserData, setLeaderboardUserData] = useState();
  const [leaderboardUserChampionTier, setLeaderboardUserChampionTier] =
    useState();
  const fetchLeaderboardUserData = async (leaderboardUserUid) => {
    try {
      setIsLoading(true);
      const q = query(
        collection(db, "users"),
        where("uid", "==", leaderboardUserUid)
      );
      const doc = await getDocs(q);
      const data = doc.docs[0].data();

      const championPoints = data.championPoints;
      if (championPoints === 0) {
        setLeaderboardUserChampionTier("TIER 0");
      } else if (championPoints >= 1 && championPoints <= 99) {
        setLeaderboardUserChampionTier("TIER 1");
      } else if (championPoints >= 100 && championPoints <= 199) {
        setLeaderboardUserChampionTier("TIER 2");
      } else if (championPoints >= 200 && championPoints <= 299) {
        setLeaderboardUserChampionTier("TIER 3");
      } else if (championPoints >= 300 && championPoints <= 399) {
        setLeaderboardUserChampionTier("TIER 4");
      } else if (championPoints >= 400 && championPoints <= 499) {
        setLeaderboardUserChampionTier("TIER 5");
      } else if (championPoints >= 500 && championPoints <= 599) {
        setLeaderboardUserChampionTier("TIER 6");
      } else if (championPoints >= 600 && championPoints <= 699) {
        setLeaderboardUserChampionTier("TIER 7");
      } else if (championPoints >= 700 && championPoints <= 799) {
        setLeaderboardUserChampionTier("TIER 8");
      } else if (championPoints >= 800 && championPoints <= 899) {
        setLeaderboardUserChampionTier("TIER 9");
      } else if (championPoints >= 900) {
        setLeaderboardUserChampionTier("TIER 10");
      }

      setLeaderboardUserData(data);

      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching user data");
    }
  };

  const [achievementsUnlocked, setAchievementsUnlocked] = useState();
  const [leaderboardUserStats, setLeaderboardUserStats] = useState([]);
  const fetchAchievements = async (leaderboardUserUid) => {
    try {
      setIsLoading(true);

      let fetchedAchievementsUnlocked = 0;

      const q = query(collection(db, "achievements"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newAchievement = doc.data();
        if (newAchievement.achieverUids.includes(leaderboardUserUid)) {
          fetchedAchievementsUnlocked += 1;
        }
      });

      setAchievementsUnlocked(fetchedAchievementsUnlocked);

      setIsLoading(false);
    } catch (err) {
      alert("An error occured while fetching achievements unlocked");
    }
  };

  const calculateUserStatsPerGroup = (userUid) => {
    const statsPerGroup = [];

    groups?.forEach((group) => {
      let challengesWon = 0;
      let points = 0;
      let starPoints = 0;

      // Calculate challenges won for this group
      room?.challenges?.forEach((challenge) => {
        if (
          challenge.event.groupUid === group.uid &&
          challenge.bets.some(
            (bet) =>
              bet.bettorUid === userUid && bet.result === challenge.result
          )
        ) {
          challengesWon++;
        }
      });

      // Calculate points for this group
      room?.submissions?.forEach((submission) => {
        if (
          submission.groupUid === group.uid &&
          submission.submitterUid === userUid
        ) {
          if (room?.leagueSport === "RACING") {
            // Racing points logic
            if (
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              starPoints += 2;
            }
            if (
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              starPoints += 2;
            }
            if (
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              starPoints += 2;
            }
            if (
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              points += 1;
            }
            if (
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              points += 1;
            }
            if (
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              points += 1;
            }
            if (
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              points += 1;
            }
            if (
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              points += 1;
            }
            if (submission?.positions.fastestLapDriver === group?.fastestLap) {
              points += 1;
            }
          } else {
            // Team sports points logic
            submission?.events.forEach((event) => {
              const groupEvent = group?.events.find(
                (e) =>
                  e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam
              );

              if (event.selectedResult === groupEvent?.result) {
                if (event.isStarGame) {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    starPoints += 1;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    starPoints += 4;
                  } else {
                    starPoints += 6;
                  }
                } else {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    points += 0.25;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    points += 2;
                  } else {
                    points += 3;
                  }
                }
              } else if (
                groupEvent?.result === "Draw" &&
                (event.selectedResult === "Home" ||
                  event.selectedResult === "Away")
              ) {
                if (event.isStarGame) {
                  starPoints += 2;
                } else {
                  points += 1;
                }
              }
            });
          }
        }
      });

      const total = points + starPoints;

      // Only add groups where the user has participated (has submissions)
      if (
        room?.submissions?.some(
          (s) => s.groupUid === group.uid && s.submitterUid === userUid
        )
      ) {
        statsPerGroup.push({
          group: group.name,
          challengesWon,
          points,
          starPoints,
          total,
        });
      }
    });

    setLeaderboardUserStats(statsPerGroup);
  };

  const handleUserClick = (params) => {
    toggleLeaderboardUserModal(params.row);
    fetchLeaderboardUserData(params.row.uid);
    fetchAchievements(params.row.uid);
    calculateUserStatsPerGroup(params.row.uid);
  };

  const toggleSelectedResult = (event, result) => {
    let newGroup = { ...groupForModal };
    let newEvents = [...newGroup?.events];

    newEvents?.forEach((e) => {
      if (e === event) {
        e.selectedResult = result;
      }
    });

    newGroup.events = newEvents;
    setGroupForModal(newGroup);
  };

  // FORMULA 1

  const [firstPolePositionDriver, setFirstPolePositionDriver] = useState("");
  const [secondPolePositionDriver, setSecondPolePositionDriver] = useState("");
  const [thirdPolePositionDriver, setThirdPolePositionDriver] = useState("");
  const [fourthPlaceDriver, setFourthPlaceDriver] = useState("");
  const [fifthPlaceDriver, setFifthPlaceDriver] = useState("");
  const [sixthPlaceDriver, setSixthPlaceDriver] = useState("");
  const [seventhPlaceDriver, setSeventhPlaceDriver] = useState("");
  const [eighthPlaceDriver, setEighthPlaceDriver] = useState("");
  const [fastestLapDriver, setFastestLapDriver] = useState("");

  //

  const isSubmitGroupVoteBtnDisabled = () => {
    let isDisabled = false;

    if (groupForModal?.sport === "Racing") {
      if (
        !firstPolePositionDriver ||
        !secondPolePositionDriver ||
        !thirdPolePositionDriver ||
        !fourthPlaceDriver ||
        !fifthPlaceDriver ||
        !sixthPlaceDriver ||
        !seventhPlaceDriver ||
        !eighthPlaceDriver ||
        !fastestLapDriver
      ) {
        isDisabled = true;
      }
    } else {
      groupForModal?.events?.forEach((event) => {
        if (!event.selectedResult) {
          isDisabled = true;
        }
      });
    }

    return isDisabled;
  };

  const submitGroupVote = async () => {
    Swal.fire({
      text: "Are you sure you want to submit your vote?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SUBMIT",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);
            let newSubmissions = [...newRoom.submissions];

            const newSubmission = {
              submitterUid: user.uid,
              groupUid: groupForModal.uid,
              events: groupForModal?.events ? groupForModal?.events : null,
              positions:
                groupForModal?.sport === "Racing"
                  ? {
                      firstPolePositionDriver,
                      secondPolePositionDriver,
                      thirdPolePositionDriver,
                      fourthPlaceDriver,
                      fifthPlaceDriver,
                      sixthPlaceDriver,
                      seventhPlaceDriver,
                      eighthPlaceDriver,
                      fastestLapDriver,
                    }
                  : null,
            };

            const alreadyExists = newSubmissions.some(
              (submission) =>
                submission.groupUid === newSubmission.groupUid &&
                submission.submitterUid === newSubmission.submitterUid
            );

            if (!alreadyExists) {
              newSubmissions.push(newSubmission);

              await updateDoc(getRoom, {
                submissions: newSubmissions,
              });
            } else {
              Swal.fire({
                text: "You already submitted a vote for this group!",
                icon: "success",
                confirmButtonColor: "#005EE1",
                confirmButtonText: "OKAY",
              });
              fetchRoom();
              toggleGroupModal();
              setIsLoading(false);
            }
          });

          Swal.fire({
            text: "Vote submitted!",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });
          fetchRoom();
          toggleGroupModal();
          setIsLoading(false);
        } catch (err) {
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const getPlayerVote = (event) => {
    let submission;

    room?.submissions?.forEach((sub) => {
      if (
        sub.groupUid === groupForModal?.uid &&
        sub.submitterUid === user?.uid
      ) {
        submission = sub;
      }
    });

    let vote = null;

    submission?.events?.forEach((submissionEvent) => {
      if (
        submissionEvent.awayTeam === event.awayTeam &&
        submissionEvent.homeTeam === event.homeTeam
      ) {
        vote = submissionEvent.selectedResult;
      }
    });

    return vote;
  };

  const [challengeModalIsVisible, setChallengeModalIsVisible] = useState(false);
  const [challengeModalTab, setChallengeModalTab] = useState("challenges");
  const [challengeEvent, setChallengeEvent] = useState();
  const [resultForChallenge, setResultForChallenge] = useState("");
  const [betForChallenge, setBetForChallenge] = useState("");
  const toggleChallengeModal = (event) => {
    setChallengeModalTab("challenges");
    if (event) {
      setChallengeEvent(event);
    }
    setChallengeModalIsVisible(!challengeModalIsVisible);
  };

  const eventHasChallenges = (event) => {
    return room?.challenges?.some(
      (challenge) =>
        challenge.event.homeTeam === event.homeTeam &&
        challenge.event.awayTeam === event.awayTeam
    );
  };

  const submitChallenge = () => {
    Swal.fire({
      text: "Are you sure you want to submit this challenge?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SUBMIT",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [];

            if (newRoom.challenges) {
              newChallenges = [...newRoom.challenges];
            }

            const newChallenge = {
              uid: uuidv4(),
              submitterUid: user?.uid,
              submitterName: userData?.username,
              event: challengeEvent,
              starCoins: parseInt(betForChallenge),
              result: resultForChallenge,
              prizePool: parseInt(betForChallenge),
              isRewardClaimed: false,
              bets: [
                {
                  bettorUid: user?.uid,
                  bettorName: userData?.username,
                  result: resultForChallenge,
                },
              ],
            };

            newChallenges.push(newChallenge);

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          const q1 = query(
            collection(db, "users"),
            where("uid", "==", user?.uid)
          );
          const docs1 = await getDocs(q1);
          docs1?.forEach(async (userObject) => {
            const newUser = userObject.data();
            const getUser = doc(db, "users", userObject.id);
            let newStarCoins = newUser.starCoins;

            newStarCoins -= parseInt(betForChallenge);

            await updateDoc(getUser, {
              starCoins: newStarCoins,
            });
          });

          Swal.fire({
            text: "Challenge submitted!",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          // Send email notification (single EmailJS template + per-recipient translations)
          const serviceId = "sportleague_outlook";
          const templateId = "challenge_submitted"; // template must use variables like {{subject}}, {{greeting}}, {{buttonText}}, {{linkToRoom}}, etc.
          const publicKey = "Ki5BETKiWrS6RDEP_";

          // Full translation map for the email template (used to populate template variables)
          // Keys include full paragraph copy so we can send completely localized emails per recipient
          const emailTranslations = {
            en: {
              subject: "There's a new challenge in {leagueName}'s {groupName}!",
              greeting: "Hi",
              // allow simple HTML in paragraphIntro (we'll pass <strong>/<em> around league/group)
              paragraphIntro:
                "A new challenge was submitted in <strong>{leagueName}</strong> — <em>{groupName}</em>.",
              paragraphAction:
                "You can view the challenge and place your response or accept it by visiting the room.",
              buttonText: "GO TO SPORTLEAGUE",
              fallbackIntro:
                "If the button above doesn't work, copy and paste this link into your browser:",
              footerNotice:
                "You are receiving this email because you're a member of {leagueName}. Manage your notification settings in your account.",
              copyright: "© 2025 Sportleague. All rights reserved.",
            },
            es: {
              subject: "¡Hay un nuevo desafío en {leagueName} de {groupName}!",
              greeting: "Hola",
              paragraphIntro:
                "Se ha enviado un nuevo desafío en <strong>{leagueName}</strong> — <em>{groupName}</em>.",
              paragraphAction:
                "Puedes ver el desafío y responder o aceptarlo visitando la sala.",
              buttonText: "IR A SPORTLEAGUE",
              fallbackIntro:
                "Si el botón anterior no funciona, copia y pega este enlace en tu navegador:",
              footerNotice:
                "Recibes este correo porque eres miembro de {leagueName}. Administra tus ajustes de notificación en tu cuenta.",
              copyright: "© 2025 Sportleague. Todos los derechos reservados.",
            },
          };

          // Build list of members to notify (exclude sender)
          const membersToNotify = (room?.members || []).filter(
            (m) => m?.uid && m.uid !== user?.uid && m?.email && m?.name
          );

          // Resolve languages for members in batches (Firestore 'in' supports up to 10)
          const uidsNeedingLookup = membersToNotify
            .filter((m) => !m?.language || !m.language?.value)
            .map((m) => m.uid);

          const uidToLang = {};
          const chunkSize = 10;
          for (let i = 0; i < uidsNeedingLookup.length; i += chunkSize) {
            const chunk = uidsNeedingLookup.slice(i, i + chunkSize);
            try {
              const q = query(
                collection(db, "users"),
                where("uid", "in", chunk)
              );
              const docs = await getDocs(q);
              docs.forEach((docSnap) => {
                const data = docSnap.data();
                if (data?.uid) {
                  uidToLang[data.uid] = data?.language?.value || "es";
                }
              });
            } catch (err) {}
          }

          // Send emails sequentially to avoid rate issues; build template params with translations
          for (const member of membersToNotify) {
            const langFromMember = member?.language?.value;
            const lang = langFromMember || uidToLang[member.uid] || "es";
            const t = emailTranslations[lang] || emailTranslations["es"];

            const subject = t.subject
              .replace("{leagueName}", league?.name || "")
              .replace("{groupName}", groupForModal?.name || "");

            // Build localized paragraph and footer strings (inject league/group where needed)
            const paragraphIntro = (t.paragraphIntro || "")
              .replace("{leagueName}", league?.name || "")
              .replace("{groupName}", groupForModal?.name || "");

            const paragraphAction = t.paragraphAction || "";
            const fallbackIntro =
              t.fallbackIntro ||
              "If the button above doesn't work, copy and paste this link into your browser:";
            const footerNotice = (t.footerNotice || "").replace(
              "{leagueName}",
              league?.name || ""
            );
            const copyright =
              t.copyright || "© 2025 Sportleague. All rights reserved.";

            const templateParams = {
              toEmail: member.email,
              toUsername: member.name,
              leagueName: league?.name,
              groupName: groupForModal?.name,
              linkToRoom: `https://app.sportleague.com/play/leagues/${leagueUid}/rooms/${roomUid}`,
              subject,
              greeting: t.greeting,
              paragraphIntro,
              paragraphAction,
              buttonText: t.buttonText,
              fallbackIntro,
              footerNotice,
              copyright,
            };

            try {
              await emailjs.send(
                serviceId,
                templateId,
                templateParams,
                publicKey
              );
            } catch (err) {}
          }
          //

          fetchRoom();
          setResultForChallenge();
          setBetForChallenge();
          toggleChallengeModal();
          setIsLoading(false);
        } catch (err) {
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const acceptChallenge = async (challenge) => {
    // Prevent accepting when the current user doesn't have enough star coins
    const required = parseFloat(challenge.starCoins) || 0;
    const available = parseFloat(userData?.starCoins) || 0;
    if (available < required) {
      Swal.fire({
        text: "You don't have enough Star Coins to accept this challenge.",
        icon: "warning",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });
      return;
    }
    Swal.fire({
      text: "Are you sure you want to accept this challenge?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, ACCEPT",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [...newRoom.challenges];

            let challengeToUpdate = newChallenges.find(
              (e) => e.uid === challenge.uid
            );

            challengeToUpdate.challengerUid = user?.uid;
            challengeToUpdate.challengerName = userData?.username;
            challengeToUpdate.prizePool += challenge.starCoins;

            challengeToUpdate.bets.push({
              bettorUid: user?.uid,
              bettorName: userData?.username,
              result: challenge.result === "Home" ? "Away" : "Home",
            });

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          const q1 = query(
            collection(db, "users"),
            where("uid", "==", user?.uid)
          );
          const docs1 = await getDocs(q1);
          docs1?.forEach(async (userObject) => {
            const newUser = userObject.data();
            const getUser = doc(db, "users", userObject.id);
            let newStarCoins = newUser.starCoins;

            newStarCoins -= challenge.starCoins;

            await updateDoc(getUser, {
              starCoins: newStarCoins,
            });
          });

          Swal.fire({
            text: "Challenge accepted!",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchRoom();
          setResultForChallenge();
          setBetForChallenge();
          setChallengeModalIsVisible(false);
          setIsLoading(false);
        } catch (err) {
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const cancelChallenge = async (challenge) => {
    Swal.fire({
      text: "Are you sure you want to cancel this challenge?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, I'M SURE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
          const docs = await getDocs(q);
          docs?.forEach(async (room) => {
            const newRoom = room.data();
            const getRoom = doc(db, "rooms", room.id);

            let newChallenges = [...newRoom.challenges];

            newChallenges = newChallenges.filter(
              (e) => e.uid !== challenge.uid
            );

            await updateDoc(getRoom, {
              challenges: newChallenges,
            });
          });

          const bettors = [];

          challenge.bets.forEach((bet) => {
            bettors.push(bet.bettorUid);
          });

          bettors.forEach(async (bettor) => {
            const q1 = query(
              collection(db, "users"),
              where("uid", "==", bettor)
            );
            const docs1 = await getDocs(q1);
            docs1?.forEach(async (userObject) => {
              const newUser = userObject.data();
              const getUser = doc(db, "users", userObject.id);
              let newStarCoins = newUser.starCoins;

              newStarCoins += parseInt(challenge.starCoins);

              await updateDoc(getUser, {
                starCoins: newStarCoins,
              });
            });
          });

          Swal.fire({
            text: "Challenge cancelled!",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          fetchRoom();
          setResultForChallenge();
          setBetForChallenge();
          toggleChallengeModal();
          setIsLoading(false);
        } catch (err) {
          alert(err.message);

          setIsLoading(false);
        }
      }
    });
  };

  const hasUserVoted = (group) => {
    let hasVoted = false;

    room?.submissions?.forEach((submission) => {
      if (
        submission.submitterUid === user?.uid &&
        submission.groupUid === (group ? group.uid : groupForModal?.uid)
      ) {
        hasVoted = true;
      }
    });

    return hasVoted;
  };

  const areResultsIn = (group) => {
    let resultsIn = true;

    if (group.sport === "Racing") {
      group?.drivers.forEach((driver) => {
        if (!driver.result) {
          resultsIn = false;
        }
      });
    } else {
      group?.events.forEach((event) => {
        if (!event.result) {
          resultsIn = false;
        }
      });
    }

    return resultsIn;
  };

  const getEventVoteRatio = (event, result) => {
    let groupSubmissions = [];
    room?.submissions?.forEach((submission) => {
      if (submission.groupUid === groupForModal?.uid) {
        groupSubmissions.push(submission);
      }
    });

    let eventSubmissions = [];
    groupSubmissions.forEach((submission) => {
      submission?.events.forEach((submissionEvent) => {
        if (
          submissionEvent.homeTeam === event.homeTeam &&
          submissionEvent.awayTeam === event.awayTeam
        ) {
          eventSubmissions.push(submissionEvent);
        }
      });
    });

    let homeVotes = 0;
    let drawVotes = 0;
    let awayVotes = 0;

    eventSubmissions.forEach((submission) => {
      if (submission.selectedResult === "Home") {
        homeVotes++;
      } else if (submission.selectedResult === "Draw") {
        drawVotes++;
      } else if (submission.selectedResult === "Away") {
        awayVotes++;
      }
    });

    if (result === "Home") {
      return `${(homeVotes / eventSubmissions.length) * 100}%`;
    } else if (result === "Draw") {
      return `${(drawVotes / eventSubmissions.length) * 100}%`;
    } else if (result === "Away") {
      return `${(awayVotes / eventSubmissions.length) * 100}%`;
    }
  };

  const getEventYouVotedForContainerColour = (vote, result) => {
    if (result) {
      if (vote === result) {
        return "0px 0px 0px 3px #25D366 inset";
      } else if (
        (vote === "Home" && result === "Draw") ||
        (vote === "Away" && result === "Draw")
      ) {
        return "0px 0px 0px 3px #FABB00 inset";
      } else {
        return "0px 0px 0px 3px #FF0000 inset";
      }
    } else {
      return "0px 0px 0px 3px #005EE1 inset";
    }
  };

  const getRacingPlayerVote = (position) => {
    let submission;

    room?.submissions?.forEach((sub) => {
      if (
        sub.groupUid === groupForModal?.uid &&
        sub.submitterUid === user?.uid
      ) {
        submission = sub;
      }
    });

    let vote = null;

    if (submission) {
      if (position === "firstPolePositionDriver") {
        vote = submission.positions.firstPolePositionDriver;
      } else if (position === "secondPolePositionDriver") {
        vote = submission.positions.secondPolePositionDriver;
      } else if (position === "thirdPolePositionDriver") {
        vote = submission.positions.thirdPolePositionDriver;
      } else if (position === "fourthPlaceDriver") {
        vote = submission.positions.fourthPlaceDriver;
      } else if (position === "fifthPlaceDriver") {
        vote = submission.positions.fifthPlaceDriver;
      } else if (position === "sixthPlaceDriver") {
        vote = submission.positions.sixthPlaceDriver;
      } else if (position === "seventhPlaceDriver") {
        vote = submission.positions.seventhPlaceDriver;
      } else if (position === "eighthPlaceDriver") {
        vote = submission.positions.eighthPlaceDriver;
      } else if (position === "fastestLapDriver") {
        vote = submission.positions.fastestLapDriver;
      }
    }

    return vote;
  };

  const getRacingResult = (position) => {
    let result;

    if (position === "fastestLap") {
      result = groupForModal?.fastestLap;
    } else {
      groupForModal?.drivers?.forEach((driver) => {
        if (driver.result === position) {
          result = driver.name;
        }
      });
    }

    return result;
  };

  const getDriverYouVotedForContainerColour = (vote, result, position) => {
    if (result) {
      if (vote === result) {
        return "0px 0px 0px 3px #25D366 inset";
      } else if (
        (position === 1 &&
          vote ===
            groupForModal?.drivers.find(
              (e) => e.result === "secondPolePosition"
            )?.name) ||
        (position === 1 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "thirdPolePosition")
              ?.name) ||
        (position === 2 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "firstPolePosition")
              ?.name) ||
        (position === 2 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "thirdPolePosition")
              ?.name) ||
        (position === 3 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "firstPolePosition")
              ?.name) ||
        (position === 3 &&
          vote ===
            groupForModal?.drivers.find(
              (e) => e.result === "secondPolePosition"
            )?.name) ||
        (position === 4 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fifthPlace")
              ?.name) ||
        (position === 4 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "sixthPlace")
              ?.name) ||
        (position === 4 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "seventhPlace")
              ?.name) ||
        (position === 4 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "eighthPlace")
              ?.name) ||
        (position === 5 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fourthPlace")
              ?.name) ||
        (position === 5 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "sixthPlace")
              ?.name) ||
        (position === 5 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "seventhPlace")
              ?.name) ||
        (position === 5 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "eighthPlace")
              ?.name) ||
        (position === 6 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fourthPlace")
              ?.name) ||
        (position === 6 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fifthPlace")
              ?.name) ||
        (position === 6 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "seventhPlace")
              ?.name) ||
        (position === 6 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "eighthPlace")
              ?.name) ||
        (position === 7 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fourthPlace")
              ?.name) ||
        (position === 7 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fifthPlace")
              ?.name) ||
        (position === 7 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "sixthPlace")
              ?.name) ||
        (position === 7 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "eighthPlace")
              ?.name) ||
        (position === 8 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fourthPlace")
              ?.name) ||
        (position === 8 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "fifthPlace")
              ?.name) ||
        (position === 8 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "sixthPlace")
              ?.name) ||
        (position === 8 &&
          vote ===
            groupForModal?.drivers.find((e) => e.result === "seventhPlace")
              ?.name)
      ) {
        return "0px 0px 0px 3px #FABB00 inset";
      } else {
        return "0px 0px 0px 3px #FF0000 inset";
      }
    } else {
      return "0px 0px 0px 3px #005EE1 inset";
    }
  };

  const isMvp = (group) => {
    let isGroupMvp = true;

    if (room?.leagueSport === "RACING") {
      return false;
    }

    const roomSubmission = room?.submissions?.find(
      (submission) =>
        submission.groupUid === group?.uid &&
        submission.submitterUid === user?.uid
    );
    const groupEvents = groups.find(
      (e) => e.uid === roomSubmission?.groupUid
    )?.events;

    // if (roomSubmission?.groupUid === '14acafe0-dd30-4040-b383-7fc6a7786911'){
    // e479536c-4523-4ea1-accd-cfe1103bf3be
    if (roomSubmission) {
      const roomSubmissionEvents = roomSubmission?.events;
      roomSubmissionEvents?.forEach((event) => {
        if (
          event.selectedResult !==
          groupEvents?.find(
            (e) =>
              e.homeTeam === event.homeTeam && e.awayTeam === event.awayTeam
          )?.result
        ) {
          isGroupMvp = false;
        }
      });

      // console.log(roomSubmission)
    } else {
      isGroupMvp = false;
    }

    return isGroupMvp;
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  // Prepare room metadata for header: tournament type and a human-friendly duration
  const roomTypeLabel =
    room?.tournamentType || room?.tournamenttype || ""
      ? (room?.tournamentType || room?.tournamenttype).toString()
      : null;

  const formatDate = (d) => {
    try {
      return new Date(d).toLocaleDateString();
    } catch (err) {
      return null;
    }
  };

  const roomDurationLabel = (() => {
    // Prefer an explicit duration type (e.g. 'monthly', 'weekly') when available
    if (room?.durationType) {
      const dt = room.durationType.toString();
      const map = {
        monthly: t("monthly") || "Monthly",
        weekly: t("weekly") || "Weekly",
      };
      return map[dt.toLowerCase()] || dt.charAt(0).toUpperCase() + dt.slice(1);
    }

    // Prefer explicit start/end dates when available
    if (room?.startDate && room?.endDate) {
      const s = formatDate(room.startDate);
      const e = formatDate(room.endDate);
      if (s && e) return `${s} — ${e}`;
    }

    // Fallbacks: common fields used in some rooms
    if (room?.durationDays) return `${room.durationDays} ${t("days")}`;
    if (room?.duration) return room.duration.toString();
    if (room?.season) return room.season;

    return null;
  })();

  return (
    <div id="roomPage" className="page">
      <div id="leaguePageHeader">
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        <img
          alt="leagueImage"
          src={
            league?.image
              ? league.image
              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fleagues%2FleaguePlaceholder.png?alt=media&token=91a9596c-5be9-49ec-8917-d9da4f07b702"
          }
        />
        <div>
          <p id="leaguePageHeaderName">{league?.name?.toUpperCase()}</p>
          {(roomTypeLabel || roomDurationLabel) && (
            <p
              className="roomHeaderMeta"
              style={{ marginTop: 4, fontSize: 13, color: "#9AA7D1" }}
            >
              {roomTypeLabel ? roomTypeLabel.toString().toUpperCase() : null}
              {roomDurationLabel ? (
                <span style={{ marginLeft: 3 }}>• {roomDurationLabel}</span>
              ) : null}
            </p>
          )}
        </div>
      </div>
      <Button
        onClick={() => navigate(`/forums/${roomUid}`)}
        className="primaryBtn"
        style={{ marginBottom: "0.75rem" }}
      >
        CHAT
      </Button>
      <div>
        <p className="playPageHeader" style={{ marginBottom: "0.5rem" }}>
          {t("events").toUpperCase()}
        </p>
        <div className="scrollContainer">
          {groups?.map((group) => {
            return (
              <div
                key={group.uid}
                onClick={() => toggleGroupModal(group)}
                className="roomGroupContainer"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p className="roomGroupName">
                  {group.name}
                  {isMvp(group) ? (
                    <span style={{ color: "#FABB00" }}>
                      <IoRibbon
                        style={{
                          width: 20,
                          height: 20,
                          marginLeft: "0.5rem",
                          marginRight: "0.25rem",
                        }}
                      />
                      MVP
                    </span>
                  ) : null}
                </p>
                {hasUserVoted(group) ? (
                  areResultsIn(group) ? (
                    <FaCheckDouble
                      style={{ color: "#25D366", width: 20, height: 20 }}
                    />
                  ) : (
                    <FaCheck
                      style={{ color: "#25D366", width: 20, height: 20 }}
                    />
                  )
                ) : new Date(group?.openingDateTime) < new Date() ? (
                  new Date(group?.closingDateTime) > new Date() ? (
                    <FaRegClock
                      style={{ color: "#FABB00", width: 20, height: 20 }}
                    />
                  ) : (
                    <IoClose style={{ color: "red", width: 25, height: 25 }} />
                  )
                ) : (
                  <p>{t("comingSoon")}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <Modal
        id="groupModal"
        isOpen={groupModalIsVisible}
        toggle={toggleGroupModal}
        size={"lg"}
      >
        <ModalBody>
          <div className="modalHeader" style={{ marginBottom: "1rem" }}>
            <div></div>
            <IoClose onClick={toggleGroupModal} />
          </div>
          <div>
            <h1>{groupForModal?.name?.toUpperCase()}</h1>
            <div style={{ marginTop: "1rem" }}>
              <p>
                {t("opens").toUpperCase()}{" "}
                {new Date(groupForModal?.openingDateTime).toLocaleDateString()}{" "}
                {t("at").toUpperCase()}{" "}
                {new Date(groupForModal?.openingDateTime).toLocaleTimeString()}{" "}
                - {t("closes").toUpperCase()}{" "}
                {new Date(groupForModal?.closingDateTime).toLocaleDateString()}{" "}
                {t("at").toUpperCase()}{" "}
                {new Date(groupForModal?.closingDateTime).toLocaleTimeString()}
              </p>
              {groupForModal?.sport === "Racing" ? (
                // IS RACING
                <>
                  {new Date(groupForModal?.openingDateTime) < new Date() &&
                  new Date(groupForModal?.closingDateTime) > new Date() ? (
                    // GROUP IS OPEN
                    <>
                      {hasUserVoted() ? (
                        // USER HAS VOTED
                        <>
                          <p className="roomPageRacingHeader">POLE POSITIONS</p>
                          <p className="inputLabel">⭐️ 1st Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("firstPolePositionDriver"),
                                getRacingResult("firstPolePosition"),
                                1
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("firstPolePositionDriver")}
                            </p>
                            {getRacingResult("firstPolePosition") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("firstPolePosition")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">⭐️ 2nd Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("secondPolePositionDriver"),
                                getRacingResult("secondPolePosition"),
                                2
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("secondPolePositionDriver")}
                            </p>
                            {getRacingResult("secondPolePosition") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("secondPolePosition")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">⭐️ 3rd Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("thirdPolePositionDriver"),
                                getRacingResult("thirdPolePosition"),
                                3
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("thirdPolePositionDriver")}
                            </p>
                            {getRacingResult("thirdPolePosition") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("thirdPolePosition")}
                                </p>
                              </>
                            )}
                          </div>
                          <div className="hr"></div>
                          <p className="roomPageRacingHeader">
                            TOP 8 POSITIONS
                          </p>
                          <p className="inputLabel">4th Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("fourthPlaceDriver"),
                                getRacingResult("fourthPlace"),
                                4
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("fourthPlaceDriver")}
                            </p>
                            {getRacingResult("fourthPlace") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("fourthPlace")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">5th Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("fifthPlaceDriver"),
                                getRacingResult("fifthPlace"),
                                5
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("fifthPlaceDriver")}
                            </p>
                            {getRacingResult("fifthPlace") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}: {getRacingResult("fifthPlace")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">6th Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("sixthPlaceDriver"),
                                getRacingResult("sixthPlace"),
                                6
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("sixthPlaceDriver")}
                            </p>
                            {getRacingResult("sixthPlace") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}: {getRacingResult("sixthPlace")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">7th Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("seventhPlaceDriver"),
                                getRacingResult("seventhPlace"),
                                7
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("seventhPlaceDriver")}
                            </p>
                            {getRacingResult("sixthPlace") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("seventhPlace")}
                                </p>
                              </>
                            )}
                          </div>
                          <p className="inputLabel">8th Place Driver</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("eighthPlaceDriver"),
                                getRacingResult("eighthPlace"),
                                8
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("eighthPlaceDriver")}
                            </p>
                            {getRacingResult("sixthPlace") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}:{" "}
                                  {getRacingResult("eighthPlace")}
                                </p>
                              </>
                            )}
                          </div>
                          <div className="hr"></div>
                          <p className="roomPageRacingHeader">FASTEST LAP</p>
                          <p className="inputLabel">Fastest Lap in Race</p>
                          <div
                            style={{
                              textAlign: "center",
                              borderRadius: 15,
                              padding: "0.5rem 1rem",
                              boxShadow: getDriverYouVotedForContainerColour(
                                getRacingPlayerVote("fastestLapDriver"),
                                getRacingResult("fastestLap")
                              ),
                              marginBottom: "0.5rem",
                            }}
                          >
                            <p style={{ marginBottom: 0 }}>
                              {t("youVoted")}:{" "}
                              {getRacingPlayerVote("fastestLapDriver")}
                            </p>
                            {getRacingResult("fastestLap") && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{
                                    color: "#FABB00",
                                    fontWeight: 500,
                                    marginBottom: 0,
                                  }}
                                >
                                  {t("result")}: {getRacingResult("fastestLap")}
                                </p>
                              </>
                            )}
                          </div>
                        </>
                      ) : (
                        // USER HAS NOT VOTED
                        <>
                          <p className="roomPageRacingHeader">POLE POSITIONS</p>
                          <p className="inputLabel">⭐️ 1st Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={firstPolePositionDriver}
                            onChange={(e) =>
                              setFirstPolePositionDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              1st pole position driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">⭐️ 2nd Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={secondPolePositionDriver}
                            onChange={(e) =>
                              setSecondPolePositionDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              2nd pole position driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">⭐️ 3rd Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={thirdPolePositionDriver}
                            onChange={(e) =>
                              setThirdPolePositionDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              3rd pole position driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <div className="hr"></div>
                          <p className="roomPageRacingHeader">
                            TOP 8 POSITIONS
                          </p>
                          <p className="inputLabel">4th Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={fourthPlaceDriver}
                            onChange={(e) =>
                              setFourthPlaceDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              4th place driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">5th Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={fifthPlaceDriver}
                            onChange={(e) =>
                              setFifthPlaceDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              5th place driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">6th Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={sixthPlaceDriver}
                            onChange={(e) =>
                              setSixthPlaceDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              6th place driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== seventhPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">7th Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={seventhPlaceDriver}
                            onChange={(e) =>
                              setSeventhPlaceDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              7th place driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== eighthPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <p className="inputLabel">8th Place Driver</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={eighthPlaceDriver}
                            onChange={(e) =>
                              setEighthPlaceDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              8th place driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              if (
                                driver.name !== firstPolePositionDriver &&
                                driver.name !== secondPolePositionDriver &&
                                driver.name !== thirdPolePositionDriver &&
                                driver.name !== fourthPlaceDriver &&
                                driver.name !== fifthPlaceDriver &&
                                driver.name !== sixthPlaceDriver &&
                                driver.name !== seventhPlaceDriver
                              ) {
                                return (
                                  <option value={driver.name}>
                                    {driver.name}
                                  </option>
                                );
                              } else {
                                return null;
                              }
                            })}
                          </Input>
                          <div className="hr"></div>
                          <p className="roomPageRacingHeader">FASTEST LAP</p>
                          <p className="inputLabel">Fastest Lap in Race</p>
                          <Input
                            type="select"
                            className="mainInput"
                            value={fastestLapDriver}
                            onChange={(e) =>
                              setFastestLapDriver(e.target.value)
                            }
                            defaultValue={""}
                            style={{ marginBottom: "0.5rem" }}
                          >
                            <option value="" disabled>
                              Fastest lap driver
                            </option>
                            {groupForModal?.drivers?.map((driver) => {
                              return (
                                <option value={driver.name}>
                                  {driver.name}
                                </option>
                              );
                            })}
                          </Input>
                        </>
                      )}
                    </>
                  ) : (
                    // GROUP IS CLOSED
                    <>
                      <p className="roomPageRacingHeader">POLE POSITIONS</p>
                      <p className="inputLabel">⭐️ 1st Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("firstPolePositionDriver"),
                            getRacingResult("firstPolePosition"),
                            1
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("firstPolePositionDriver")}
                        </p>
                        {getRacingResult("firstPolePosition") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}:{" "}
                              {getRacingResult("firstPolePosition")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">⭐️ 2nd Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("secondPolePositionDriver"),
                            getRacingResult("secondPolePosition"),
                            2
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("secondPolePositionDriver")}
                        </p>
                        {getRacingResult("secondPolePosition") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}:{" "}
                              {getRacingResult("secondPolePosition")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">⭐️ 3rd Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("thirdPolePositionDriver"),
                            getRacingResult("thirdPolePosition"),
                            3
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("thirdPolePositionDriver")}
                        </p>
                        {getRacingResult("thirdPolePosition") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}:{" "}
                              {getRacingResult("thirdPolePosition")}
                            </p>
                          </>
                        )}
                      </div>
                      <div className="hr"></div>
                      <p className="roomPageRacingHeader">TOP 8 POSITIONS</p>
                      <p className="inputLabel">4th Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("fourthPlaceDriver"),
                            getRacingResult("fourthPlace"),
                            4
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("fourthPlaceDriver")}
                        </p>
                        {getRacingResult("fourthPlace") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("fourthPlace")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">5th Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("fifthPlaceDriver"),
                            getRacingResult("fifthPlace"),
                            5
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("fifthPlaceDriver")}
                        </p>
                        {getRacingResult("fifthPlace") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("fifthPlace")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">6th Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("sixthPlaceDriver"),
                            getRacingResult("sixthPlace"),
                            6
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("sixthPlaceDriver")}
                        </p>
                        {getRacingResult("sixthPlace") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("sixthPlace")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">7th Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("seventhPlaceDriver"),
                            getRacingResult("seventhPlace"),
                            7
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("seventhPlaceDriver")}
                        </p>
                        {getRacingResult("sixthPlace") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("seventhPlace")}
                            </p>
                          </>
                        )}
                      </div>
                      <p className="inputLabel">8th Place Driver</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("eighthPlaceDriver"),
                            getRacingResult("eighthPlace"),
                            8
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("eighthPlaceDriver")}
                        </p>
                        {getRacingResult("sixthPlace") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("eighthPlace")}
                            </p>
                          </>
                        )}
                      </div>
                      <div className="hr"></div>
                      <p className="roomPageRacingHeader">FASTEST LAP</p>
                      <p className="inputLabel">Fastest Lap in Race</p>
                      <div
                        style={{
                          textAlign: "center",
                          borderRadius: 15,
                          padding: "0.5rem 1rem",
                          boxShadow: getDriverYouVotedForContainerColour(
                            getRacingPlayerVote("fastestLapDriver"),
                            getRacingResult("fastestLap")
                          ),
                          marginBottom: "0.5rem",
                        }}
                      >
                        <p style={{ marginBottom: 0 }}>
                          {t("youVoted")}:{" "}
                          {getRacingPlayerVote("fastestLapDriver")}
                        </p>
                        {getRacingResult("fastestLap") && (
                          <>
                            <div
                              className="hr"
                              style={{
                                marginTop: "0.25rem",
                                marginBottom: "0.25rem",
                              }}
                            ></div>
                            <p
                              style={{
                                color: "#FABB00",
                                fontWeight: 500,
                                marginBottom: 0,
                              }}
                            >
                              {t("result")}: {getRacingResult("fastestLap")}
                            </p>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </>
              ) : // IS NOT RACING
              new Date(groupForModal?.openingDateTime) < new Date() &&
                new Date(groupForModal?.closingDateTime) > new Date() ? (
                <>
                  {
                    // room?.submissions?.some(e => e.submitterUid === user?.uid)
                    hasUserVoted()
                      ? // <p style={{borderTop: '1px solid #DDDDDD', paddingTop: '1rem'}}>
                        //   You've already submitted your vote for this group. Just look out for it's closing time!
                        // </p>

                        // USER HAS VOTED
                        groupForModal?.events?.map((event) => {
                          return (
                            <div
                              key={`${event.homeTeam}-${event.awayTeam}`}
                              className="roomGroupEventContainer"
                            >
                              <div className="roomGroupEventInfoRow">
                                <p className="roomGroupEventHomeTeam">
                                  {event.homeTeam.toUpperCase()}
                                </p>
                                <p className="roomGroupEventVs">
                                  {event?.isStarGame && (
                                    <>
                                      <span>⭐</span>
                                      <br />
                                    </>
                                  )}
                                  VS
                                </p>
                                <p className="roomGroupEventAwayTeam">
                                  {event.awayTeam.toUpperCase()}
                                </p>
                              </div>
                              <div className="eventVotesHorizontalStackedBar">
                                <div
                                  style={{
                                    backgroundColor: "#005EE1",
                                    boxShadow: "0px 0px 0px 3px #005EE1 inset",
                                    borderTopLeftRadius: 20,
                                    borderBottomLeftRadius: 20,
                                    width: getEventVoteRatio(event, "Home"),
                                  }}
                                >
                                  {parseInt(getEventVoteRatio(event, "Home")) >
                                    14 && (
                                    <p>
                                      {parseInt(
                                        getEventVoteRatio(event, "Home")
                                      )}
                                      %
                                    </p>
                                  )}
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "transparent",
                                    boxShadow: "0px 0px 0px 3px #005EE1 inset",
                                    width: getEventVoteRatio(event, "Draw"),
                                  }}
                                >
                                  {parseInt(getEventVoteRatio(event, "Draw")) >
                                    14 && (
                                    <p style={{ color: "#005EE1" }}>
                                      {parseInt(
                                        getEventVoteRatio(event, "Draw")
                                      )}
                                      %
                                    </p>
                                  )}
                                </div>
                                <div
                                  style={{
                                    backgroundColor:
                                      groupForModal.league === "NFL" ||
                                      groupForModal.league === "UFL" ||
                                      groupForModal.league === "NBA" ||
                                      groupForModal.league === "MLB" ||
                                      groupForModal.league === "NHL"
                                        ? "transparent"
                                        : "#005EE1",
                                    boxShadow: "0px 0px 0px 3px #005EE1 inset",
                                    borderTopRightRadius: 20,
                                    borderBottomRightRadius: 20,
                                    width: getEventVoteRatio(event, "Away"),
                                  }}
                                >
                                  {parseInt(getEventVoteRatio(event, "Away")) >
                                    14 && (
                                    <p
                                      style={{
                                        color:
                                          groupForModal.league === "NFL" ||
                                          groupForModal.league === "UFL" ||
                                          groupForModal.league === "NBA" ||
                                          groupForModal.league === "MLB" ||
                                          groupForModal.league === "NHL"
                                            ? "#005EE1"
                                            : "#FFFFFF",
                                      }}
                                    >
                                      {parseInt(
                                        getEventVoteRatio(event, "Away")
                                      )}
                                      %
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div
                                className="eventYouVotedForContainer"
                                style={{
                                  boxShadow: getEventYouVotedForContainerColour(
                                    getPlayerVote(event),
                                    groupForModal?.events?.find(
                                      (e) =>
                                        e.homeTeam === event.homeTeam &&
                                        e.awayTeam === event.awayTeam
                                    ).result
                                  ),
                                }}
                              >
                                <p>
                                  {t("youVoted")}: {getPlayerVote(event)}
                                </p>
                                {groupForModal?.events?.some(
                                  (e) => e.result
                                ) && (
                                  <>
                                    <div
                                      className="hr"
                                      style={{
                                        marginTop: "0.25rem",
                                        marginBottom: "0.25rem",
                                      }}
                                    ></div>
                                    <p
                                      style={{
                                        color: "#FABB00",
                                        fontWeight: 500,
                                      }}
                                    >
                                      {t("result")}:{" "}
                                      {
                                        groupForModal?.events?.find(
                                          (e) =>
                                            e.homeTeam === event.homeTeam &&
                                            e.awayTeam === event.awayTeam
                                        ).result
                                      }
                                    </p>
                                  </>
                                )}
                              </div>
                              <p
                                onClick={() => toggleChallengeModal(event)}
                                style={{
                                  textAlign: "center",
                                  marginTop: "0.5rem",
                                  backgroundColor: "#005EE1",
                                  borderRadius: 15,
                                  color: "#FFFFFF",
                                  padding: "0.5rem",
                                  fontFamily: "Oswald",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                {t("challenges").toUpperCase()}
                                {eventHasChallenges(event) && (
                                  <IoWarning
                                    style={{
                                      color: "#FF0000",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      width: 24,
                                      height: 24,
                                    }}
                                  />
                                )}
                              </p>
                            </div>
                          );
                        })
                      : // USER HAS NOT VOTED
                        groupForModal?.events?.map((event) => {
                          return (
                            <div
                              key={`${event.homeTeam}-${event.awayTeam}`}
                              className="roomGroupEventContainer"
                            >
                              <div className="roomGroupEventInfoRow">
                                <p className="roomGroupEventHomeTeam">
                                  {event.homeTeam.toUpperCase()}
                                </p>
                                <p className="roomGroupEventVs">
                                  {event?.isStarGame && (
                                    <>
                                      <span>⭐</span>
                                      <br />
                                    </>
                                  )}
                                  VS
                                </p>
                                <p className="roomGroupEventAwayTeam">
                                  {event.awayTeam.toUpperCase()}
                                </p>
                              </div>
                              <div className="roomGroupEventButtonsRow">
                                <Button
                                  onClick={() =>
                                    toggleSelectedResult(event, "Home")
                                  }
                                  className={classnames(
                                    "roomGroupEventHomeBtn",
                                    {
                                      active: event.selectedResult === "Home",
                                    }
                                  )}
                                  style={{
                                    borderRight:
                                      groupForModal.league === "NFL" ||
                                      groupForModal.league === "UFL" ||
                                      groupForModal.league === "NBA" ||
                                      groupForModal.league === "MLB" ||
                                      groupForModal.league === "NHL"
                                        ? "1px solid #005EE1"
                                        : null,
                                  }}
                                >
                                  {t("home").toUpperCase()}
                                </Button>
                                {groupForModal.league === "NFL" ||
                                groupForModal.league === "UFL" ||
                                groupForModal.league === "NBA" ||
                                groupForModal.league === "MLB" ||
                                groupForModal.league === "NHL" ? null : (
                                  <Button
                                    onClick={() =>
                                      toggleSelectedResult(event, "Draw")
                                    }
                                    className={classnames({
                                      active: event.selectedResult === "Draw",
                                    })}
                                  >
                                    {t("draw").toUpperCase()}
                                  </Button>
                                )}
                                <Button
                                  onClick={() =>
                                    toggleSelectedResult(event, "Away")
                                  }
                                  className={classnames(
                                    "roomGroupEventAwayBtn",
                                    {
                                      active: event.selectedResult === "Away",
                                    }
                                  )}
                                  style={{
                                    borderLeft:
                                      groupForModal.league === "NFL" ||
                                      groupForModal.league === "UFL" ||
                                      groupForModal.league === "NBA" ||
                                      groupForModal.league === "MLB" ||
                                      groupForModal.league === "NHL"
                                        ? "1px solid #005EE1"
                                        : null,
                                  }}
                                >
                                  {t("away").toUpperCase()}
                                </Button>
                              </div>
                              <p
                                onClick={() => toggleChallengeModal(event)}
                                style={{
                                  textAlign: "center",
                                  marginTop: "0.5rem",
                                  backgroundColor: "#005EE1",
                                  borderRadius: 15,
                                  color: "#FFFFFF",
                                  padding: "0.5rem",
                                  fontFamily: "Oswald",
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "0.5rem",
                                }}
                              >
                                {t("challenges").toUpperCase()}
                                {eventHasChallenges(event) && (
                                  <IoWarning
                                    style={{
                                      color: "#FF0000",
                                      borderRadius: "50%",
                                      padding: "2px",
                                      width: 24,
                                      height: 24,
                                    }}
                                  />
                                )}
                              </p>
                            </div>
                          );
                        })
                  }
                </>
              ) : (
                // <p>
                // 	This group has closed. You can no longer submit your vote for this group.
                // </p>
                groupForModal?.events?.map((event) => {
                  return (
                    <div
                      key={`${event.homeTeam}-${event.awayTeam}`}
                      className="roomGroupEventContainer"
                    >
                      <div
                        className="roomGroupEventInfoRow"
                        style={{
                          marginBottom:
                            new Date(groupForModal?.closingDateTime) <
                            new Date()
                              ? "0.5rem"
                              : 0,
                        }}
                      >
                        <p className="roomGroupEventHomeTeam">
                          {event.homeTeam.toUpperCase()}
                        </p>
                        <p className="roomGroupEventVs">
                          {event?.isStarGame && (
                            <>
                              <span>⭐</span>
                              <br />
                            </>
                          )}
                          VS
                        </p>
                        <p className="roomGroupEventAwayTeam">
                          {event.awayTeam.toUpperCase()}
                        </p>
                      </div>
                      {new Date(groupForModal?.closingDateTime) <
                        new Date() && (
                        <div className="eventVotesHorizontalStackedBar">
                          <div
                            style={{
                              backgroundColor: "#005EE1",
                              boxShadow: "0px 0px 0px 3px #005EE1 inset",
                              borderTopLeftRadius: 20,
                              borderBottomLeftRadius: 20,
                              width:
                                parseInt(getEventVoteRatio(event, "Home")) === 0
                                  ? 10
                                  : getEventVoteRatio(event, "Home"),
                            }}
                          >
                            {parseInt(getEventVoteRatio(event, "Home")) >
                              14 && (
                              <p>
                                {parseInt(getEventVoteRatio(event, "Home"))}%
                              </p>
                            )}
                          </div>
                          <p></p>
                          <div
                            style={{
                              backgroundColor: "transparent",
                              boxShadow: "0px 0px 0px 3px #005EE1 inset",
                              width:
                                parseInt(getEventVoteRatio(event, "Draw")) === 0
                                  ? 10
                                  : getEventVoteRatio(event, "Draw"),
                            }}
                          >
                            {parseInt(getEventVoteRatio(event, "Draw")) >
                              14 && (
                              <p style={{ color: "#005EE1" }}>
                                {parseInt(getEventVoteRatio(event, "Draw"))}%
                              </p>
                            )}
                          </div>
                          <div
                            style={{
                              backgroundColor:
                                groupForModal.league === "NFL" ||
                                groupForModal.league === "UFL" ||
                                groupForModal.league === "NBA" ||
                                groupForModal.league === "MLB" ||
                                groupForModal.league === "NHL"
                                  ? "transparent"
                                  : "#005EE1",
                              boxShadow: "0px 0px 0px 3px #005EE1 inset",
                              borderTopRightRadius: 20,
                              borderBottomRightRadius: 20,
                              width:
                                parseInt(getEventVoteRatio(event, "Away")) === 0
                                  ? 10
                                  : getEventVoteRatio(event, "Away"),
                            }}
                          >
                            {parseInt(getEventVoteRatio(event, "Away")) >
                              14 && (
                              <p
                                style={{
                                  color:
                                    groupForModal.league === "NFL" ||
                                    groupForModal.league === "UFL" ||
                                    groupForModal.league === "NBA" ||
                                    groupForModal.league === "MLB" ||
                                    groupForModal.league === "NHL"
                                      ? "#005EE1"
                                      : "#FFFFFF",
                                }}
                              >
                                {parseInt(getEventVoteRatio(event, "Away"))}%
                              </p>
                            )}
                          </div>
                        </div>
                      )}
                      {new Date(groupForModal?.closingDateTime) <
                        new Date() && (
                        <>
                          <div
                            className="eventYouVotedForContainer"
                            style={{
                              boxShadow: getEventYouVotedForContainerColour(
                                room?.submissions?.some(
                                  (e) => e.submitterUid === user?.uid
                                )
                                  ? getPlayerVote(event)
                                  : "None",
                                groupForModal?.events?.find(
                                  (e) =>
                                    e.homeTeam === event.homeTeam &&
                                    e.awayTeam === event.awayTeam
                                ).result
                              ),
                            }}
                          >
                            <p>
                              {t("youVoted")}:{" "}
                              {room?.submissions?.some(
                                (e) => e.submitterUid === user?.uid
                              )
                                ? getPlayerVote(event)
                                : "None"}
                            </p>
                            {groupForModal?.events?.some((e) => e.result) && (
                              <>
                                <div
                                  className="hr"
                                  style={{
                                    marginTop: "0.25rem",
                                    marginBottom: "0.25rem",
                                  }}
                                ></div>
                                <p
                                  style={{ color: "#FABB00", fontWeight: 500 }}
                                >
                                  {t("result")}:{" "}
                                  {
                                    groupForModal?.events?.find(
                                      (e) =>
                                        e.homeTeam === event.homeTeam &&
                                        e.awayTeam === event.awayTeam
                                    ).result
                                  }
                                </p>
                              </>
                            )}
                          </div>
                          {groupForModal?.events?.some((e) => e.result) &&
                          new Date() <
                            new Date(groupForModal?.closingDateTime) ? (
                            <p
                              onClick={() => toggleChallengeModal(event)}
                              style={{
                                textAlign: "center",
                                marginTop: "0.5rem",
                                backgroundColor: "#005EE1",
                                borderRadius: 15,
                                color: "#FFFFFF",
                                padding: "0.5rem",
                                fontFamily: "Oswald",
                                fontWeight: 500,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "0.5rem",
                              }}
                            >
                              {t("challenges").toUpperCase()}
                              {eventHasChallenges(event) && (
                                <IoWarning
                                  style={{
                                    color: "#FF0000",
                                    borderRadius: "50%",
                                    padding: "2px",
                                    width: 24,
                                    height: 24,
                                  }}
                                />
                              )}
                            </p>
                          ) : null}
                        </>
                      )}
                    </div>
                  );
                })
              )}
            </div>
            {hasUserVoted() ? null : ( // room?.submissions?.some(e => e.submitterUid === user?.uid)
              <Button
                onClick={submitGroupVote}
                className="primaryBtn"
                style={{ marginTop: "1rem" }}
                disabled={isSubmitGroupVoteBtnDisabled()}
              >
                {t("submit").toUpperCase()}
              </Button>
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal
        id="groupModal"
        isOpen={challengeModalIsVisible}
        toggle={toggleChallengeModal}
        size={"lg"}
      >
        <ModalBody>
          <div className="modalHeader" style={{ marginBottom: "1rem" }}>
            <div></div>
            <IoClose onClick={toggleChallengeModal} />
          </div>
          <div>
            <h1>{t("challenges").toUpperCase()}</h1>
            <div style={{ marginTop: "1rem" }}>
              <div
                className="roomGroupEventInfoRow"
                style={{ marginBottom: 0 }}
              >
                <p
                  className="roomGroupEventVs"
                  style={{
                    width: "45%",
                    marginBottom: 0,
                  }}
                >
                  {t("home").toUpperCase()}
                </p>
                <p className="roomGroupEventVs" style={{ marginBottom: 0 }}></p>
                <p
                  className="roomGroupEventVs"
                  style={{
                    width: "45%",
                    marginBottom: 0,
                  }}
                >
                  {t("away").toUpperCase()}
                </p>
              </div>
              <div className="roomGroupEventInfoRow">
                <p className="roomGroupEventHomeTeam">
                  {challengeEvent?.homeTeam?.toUpperCase()}
                </p>
                <p className="roomGroupEventVs">VS</p>
                <p className="roomGroupEventAwayTeam">
                  {challengeEvent?.awayTeam?.toUpperCase()}
                </p>
              </div>
              {challengeModalTab === "challenges" ? (
                <>
                  {!room?.challenges?.some(
                    (e) =>
                      (e.submitterUid === user?.uid ||
                        e.challengerUid === user?.uid) &&
                      e.event.homeTeam === challengeEvent?.homeTeam &&
                      e.event.awayTeam === challengeEvent?.awayTeam
                  ) ? (
                    <button
                      onClick={() => setChallengeModalTab("create challenge")}
                      className="primaryBtn"
                    >
                      {t("createChallenge").toUpperCase()}
                    </button>
                  ) : null}
                  {room?.challenges?.some(
                    (e) =>
                      e.event.homeTeam === challengeEvent?.homeTeam &&
                      e.event.awayTeam === challengeEvent?.awayTeam
                  ) ? (
                    room?.challenges
                      ?.filter(
                        (e) =>
                          e.event.homeTeam === challengeEvent?.homeTeam &&
                          e.event.awayTeam === challengeEvent?.awayTeam
                      )
                      .map((challenge) => {
                        return (
                          <div
                            key={`${challenge.submitterUid}-${challenge.starCoins}-${challenge.result}`}
                            className="eventChallengeCard"
                          >
                            <p>
                              <span className="eventChallengeSubmitterName">
                                {challenge?.submitterUid !== user?.uid
                                  ? challenge.submitterName
                                  : "You"}
                              </span>{" "}
                              {challenge?.submitterUid !== user?.uid
                                ? "has"
                                : "have"}{" "}
                              <span className="eventChallengeTickets">
                                {challenge.starCoins}
                              </span>{" "}
                              star coins on{" "}
                              <span className="eventChallengeResult">
                                {challenge.result.toUpperCase()}
                              </span>
                              {challenge?.challengerUid && (
                                <>
                                  {" "}
                                  against{" "}
                                  <span className="eventChallengeSubmitterName">
                                    {challenge?.challengerUid === user?.uid
                                      ? "you"
                                      : challenge?.challengerName}
                                  </span>
                                </>
                              )}
                            </p>
                            {challenge?.submitterUid === user?.uid ? (
                              <button
                                onClick={() => cancelChallenge(challenge)}
                                className="primaryBtn"
                                style={{
                                  marginTop: "0.5rem",
                                  backgroundColor: "#FF0000",
                                }}
                              >
                                {t("cancel").toUpperCase()}
                              </button>
                            ) : (
                              // DONT ALLOW ACCEPTANCE IF CHALLENGE ALREADY HAS A CHALLENGER
                              !challenge.challengerUid && (
                                <button
                                  onClick={() => acceptChallenge(challenge)}
                                  className="primaryBtn"
                                  style={{
                                    marginTop: "0.5rem",
                                    backgroundColor: "#25D366",
                                    opacity:
                                      (userData?.starCoins || 0) <
                                      (parseFloat(challenge.starCoins) || 0)
                                        ? 0.5
                                        : 1,
                                    cursor:
                                      (userData?.starCoins || 0) <
                                      (parseFloat(challenge.starCoins) || 0)
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                  disabled={
                                    (userData?.starCoins || 0) <
                                    (parseFloat(challenge.starCoins) || 0)
                                  }
                                  title={
                                    (userData?.starCoins || 0) <
                                    (parseFloat(challenge.starCoins) || 0)
                                      ? "Not enough Star Coins"
                                      : ""
                                  }
                                >
                                  {t("accept").toUpperCase()}
                                </button>
                              )
                            )}
                            {/* {console.log(challenge)} */}
                          </div>
                        );
                      })
                  ) : (
                    <p
                      style={{
                        paddingTop: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {t("thereAreNoChallengesForThisEventYet")}
                    </p>
                  )}
                </>
              ) : (
                <>
                  <p className="inputLabel" style={{ textAlign: "left" }}>
                    {t("result")}
                  </p>
                  <Input
                    type="select"
                    className="mainInput"
                    value={resultForChallenge}
                    onChange={(e) => setResultForChallenge(e.target.value)}
                    defaultValue={""}
                    style={{ marginBottom: "0.5rem" }}
                  >
                    <option value="" disabled>
                      {t("theEventsResult")}
                    </option>
                    <option value={"Home"}>{t("home")}</option>
                    <option value={"Away"}>{t("away")}</option>
                  </Input>
                  <p className="inputLabel" style={{ textAlign: "left" }}>
                    {t("bet(YouHave")}{" "}
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "#FABB00",
                      }}
                    >
                      {userData.starCoins}
                    </span>{" "}
                    {t("starCoins)")}
                  </p>
                  <input
                    type="number"
                    className="mainInput"
                    value={betForChallenge}
                    onChange={(e) => setBetForChallenge(e.target.value)}
                    placeholder={t("yourBetForTheResult")}
                  />
                  <Button
                    onClick={submitChallenge}
                    className="primaryBtn"
                    style={{ marginTop: "1rem" }}
                    disabled={
                      !resultForChallenge ||
                      !betForChallenge ||
                      betForChallenge < 100 ||
                      betForChallenge > 2000 ||
                      parseFloat(betForChallenge) > userData?.starCoins
                    }
                  >
                    {t("submitChallenge").toUpperCase()}
                  </Button>
                  <Button
                    onClick={() => setChallengeModalTab("challenges")}
                    className="secondaryBtn"
                    style={{
                      marginTop: "0.5rem",
                      color: "#005EE1",
                    }}
                  >
                    {t("cancel").toUpperCase()}
                  </Button>
                </>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
      <div>
        <p
          className="playPageHeader"
          style={{ marginBottom: "-0.5rem", marginTop: "1rem" }}
        >
          {t("leaderboard").toUpperCase()}
        </p>
        <DataGridPro
          getRowId={(row) => row.uid}
          rows={roomMembers ? roomMembers : []}
          columns={leaderboardColumns}
          // initialState={{
          //   pagination: {
          //     paginationModel: { page: 0, pageSize: 10 },
          //   },
          // }}
          // pageSizeOptions={[10, 25, 50, 100]}
          onRowClick={handleUserClick}
          checkboxSelection={false}
          slots={{ toolbar: GridToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
              showQuickFilter: true,
            },
          }}
        />
        <Modal
          id="leaderboardUserModal"
          isOpen={leaderboardUserModalIsVisible}
          toggle={toggleLeaderboardUserModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleLeaderboardUserModal} />
            </div>
            <div>
              <div style={{ marginTop: "1rem" }}>
                <div>
                  <img
                    alt="bannerImage"
                    src={leaderboardUserData?.bannerDesktop}
                    style={{
                      width: "100%",
                      borderRadius: 20,
                      cursor: "pointer",
                    }}
                    className="hideOnMobile"
                  />
                  <img
                    alt="bannerImage"
                    src={leaderboardUserData?.bannerMobile}
                    style={{
                      width: "100%",
                      borderRadius: 20,
                      cursor: "pointer",
                    }}
                    className="hideOnDesktop"
                  />
                  <div
                    className="underProfileBannerContainer"
                    style={{ marginBottom: 0 }}
                  >
                    <Avatar
                      src={
                        leaderboardUserData?.avatar
                          ? leaderboardUserData.avatar
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Favatars%2FdefaultAvatar.png?alt=media&token=4fe7a7cf-b2a3-42bf-9d0a-067cb0fcfd72"
                      }
                      size={168}
                      user={leaderboardUserData}
                      style={{ marginRight: "1rem" }}
                    />
                    <div className="underProfileBannerTextContainer">
                      <p
                        style={{
                          color: "#FFFFFF",
                          marginBottom: 0,
                          fontSize: 32,
                          fontWeight: 700,
                        }}
                      >
                        {leaderboardUserData?.username}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          fontSize: 15,
                        }}
                      >
                        <p style={{ color: "#FFFFFF", marginRight: "1rem" }}>
                          ⭐{" "}
                          {leaderboardUserData?.starCoins
                            ? leaderboardUserData.starCoins
                            : 0}
                        </p>
                        <p style={{ color: "#FFFFFF", marginRight: "1rem" }}>
                          🏆 {achievementsUnlocked}
                        </p>
                        <p style={{ color: "#FFFFFF" }}>
                          🎟️{" "}
                          {leaderboardUserData?.tickets
                            ? leaderboardUserData.tickets
                            : 0}
                        </p>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() =>
                      navigate(
                        `/account/friends/${leaderboardUserData?.username}`
                      )
                    }
                    className="primaryBtn"
                    style={{ marginBottom: "1rem" }}
                  >
                    {t("goToProfile").toUpperCase()}
                  </button>
                  <div
                    className="accountPageMenuItem"
                    style={{
                      boxShadow: "none",
                      paddingTop: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <p>
                      {t("championsRoad").toUpperCase()}{" "}
                      <span>
                        {leaderboardUserChampionTier
                          ? leaderboardUserChampionTier
                          : "TIER 0"}
                      </span>
                    </p>
                  </div>
                  <div
                    className="accountPageMenuItem"
                    style={{
                      boxShadow: "none",
                      paddingTop: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                    }}
                  >
                    <p>
                      {t("achievements").toUpperCase()}{" "}
                      <span>{achievementsUnlocked}</span>
                    </p>
                  </div>
                </div>
                <DataGridPro
                  getRowId={(row) => row.group}
                  rows={leaderboardUserStats}
                  columns={leaderboardUserColumns}
                  // initialState={{
                  //   pagination: {
                  //     paginationModel: { page: 0, pageSize: 10 },
                  //   },
                  // }}
                  // pageSizeOptions={[10, 25, 50, 100]}
                  checkboxSelection={false}
                  slots={{ toolbar: GridToolbar }}
                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  slotProps={{
                    toolbar: {
                      printOptions: { disableToolbarButton: true },
                      csvOptions: { disableToolbarButton: true },
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </div>
          </ModalBody>
        </Modal>
        {/* <div className='leaderboard'>
          <div className='leaderboardHeader'>
            <p className='leaderboardPlace'>
              PLACE
            </p>
            <p className='leaderboardName'>
              NAME
            </p>
            <p className='leaderboardPoints'>
              POINTS
            </p>
          </div>
          {
            roomMembers?.map(member => {
              return (
                <div className='leaderboardRow'>
                  <p className='leaderboardPlace'>
                    {(roomMembers.indexOf(member)) + 1}
                  </p>
                  <p className='leaderboardName'>
                    {member.name}
                  </p>
                  <p className='leaderboardPoints'>
                    {member.points}
                  </p>
                </div>
              )
            })
          }
        </div> */}
      </div>
      {room?.isActive ? (
        <Button
          onClick={leaveRoom}
          className="primaryBtn"
          style={{ marginTop: "2rem" }}
        >
          {t("leaveRoom").toUpperCase()}
        </Button>
      ) : null}
    </div>
  );
}

export default RoomPage;
